const state = {
  rev: {
    problemBreakdown: {},
    id: '',
    name: '',
    author: {},
    location: {
      organization: {},
      site: {},
      tags: [],
    },
    team: {
      owner: {},
      coach: null,
      collaborators: [],
    },
    notes: '',
    status: '',
    categories: [],
    currencyMetadata: {
      exchangeRate: 1,
      currentCurrency: '',
      globalCurrency: '',
    },
    problemAnalysis: {
      problem: '',
      problemMedia: [],
      goals: '',
      containment: '',
      countermeasuresMedia: [],
      rootCauseMedia: [],
      businessRequirements: '',
    },
    rootCauses: [
      {
        id: '',
        name: '',
        type: '',
        description: '',
        correctiveAction: '',
        correctiveActionWorked: true,
        correctiveActionMedia: [],
        preventiveAction: '',
        position: 1,
      },
    ],
    reviewPhase: {
      costReduction: {
        capturedValue: null,
        calculatedValue: 0,
      },
      investment: {
        capturedValue: null,
        calculatedValue: 0,
      },
      revenue: {
        capturedValue: null,
        calculatedValue: 0,
      },
      estimationExplanation: '',
      timeTracking: {
        timeReductionByMonth: null,
        timeInvested: null,
      },
    },
    currentPhase: '',
    createdAt: '',
    updatedAt: '',
    points: 0,
    likedByMe: false,
    approvedByMe: '',
    approvals: [],
    isApproved: false,
    totalLikes: 0,
    type: 'problemSolving',
  },
  availableOwners: [],
  availableCollaborators: [],
  availableCoaches: [],
  onHoldReason: null,
  onHoldBy: null,
  onHoldAt: null,
  canceledReason: null,
  canceledBy: null,
  canceledAt: null,
  impactStartsAt: null,
  impactEndsAt: null,
}

export default state
